function annimationCheck() {
  let arrayLabel = document.querySelectorAll(".form-group__label");
  arrayLabel.forEach((label) => {
    let input = label.nextElementSibling;
    if (input.value !== "") {
      label.classList.add("form-group__focus");
    } else {
      label.classList.remove("form-group__focus");
    }
  });
}

if (document.querySelector(".form-group__input") !== undefined || document.querySelector(".form-group__textarea") !== undefined) {
  document.addEventListener("focus", (event) => {
    let e = event.target;
    if (e.type !== "file" && e.type !== "select-one" && (e.nodeName === "INPUT" || e.nodeName === "TEXTAREA") && e.previousElementSibling.classList.contains("form-group__label")) {
      e.previousElementSibling.classList.add("form-group__focus");
    }
  }, true);

  document.addEventListener("blur", (event) => {
    let e = event.target;
    if (e.type !== "file" && e.type !== "select-one" && (e.nodeName === "INPUT" || e.nodeName === "TEXTAREA") && e.previousElementSibling.classList.contains("form-group__label")) {
      if (e.value === "") {
        e.previousElementSibling.classList.remove("form-group__focus");
      } else {
        e.previousElementSibling.classList.add("form-group__focus");
      }
    }
  }, true);

  window.addEventListener("load", annimationCheck);
}